
import styled, { keyframes } from "styled-components";
import loader from "./loader.png";

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const colorize = keyframes`
  0% {
    filter: grayscale(100%) brightness(2.0);
    opacity: 0.6;
  }
  100% {
    filter: grayscale(0%);
    opacity: 1;
  }
`;

const Loader = ({ fade }) => {
  return (
    <Wrapper fade={fade}>
      <Logo src={loader} alt="logo" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('./img/background2.png');
  z-index: 9999;

  animation: ${({ fade }) => (fade ? fadeOut : "none")} 0.6s ease forwards;
`;

const Logo = styled.img`
  width: 300px;
  animation: ${colorize} 1.8s ease forwards;
`;

export default Loader;